export default __webpack_public_path__ + "static/media/tezos.b4ffaf58.svg";